import React from 'react';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { IconButton } from '@mui/material';
import ConditionalTooltip from '../../_common/ConditionalTooltip/ConditionalTooltip';
import styled from '@emotion/styled';

type PrimaryStarButtonProps = {
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

const PrimaryStarButton = ({ selected = false, disabled = false, onClick }: PrimaryStarButtonProps) => (
  <ConditionalTooltip show={!disabled} title="Set as Primary" placement="top">
    <StyledIconButton
      color="default"
      selected_star={+selected}
      disabled_star={+disabled}
      unselected_star={+(disabled && !selected)}
      sx={{ ml: -1 }}
      onClick={onClick}
    >
      <PolarisIcon icon={selected ? 'star_filled' : 'star'} height={20} />
    </StyledIconButton>
  </ConditionalTooltip>
);

export default PrimaryStarButton;

const StyledIconButton = styled(IconButton)<{
  selected_star: number;
  disabled_star: number;
  unselected_star: number;
}>`
  opacity: 0.5;
  margin-right: ${({ theme }) => theme.spacing(0.5)};
  transition: ease opacity 0.2s;

  ${({ selected_star, theme }) =>
    selected_star &&
    `
    opacity: 1;
    transition: ease opacity 0.2s;
    color: ${theme.palette.warning.main};
    & + p {
      font-weight: bold;
    }
  `}

  ${({ disabled_star }) =>
    disabled_star &&
    `
    pointer-events: none;
    cursor: default;
    opacity: 0.5;
  `}

  ${({ unselected_star }) =>
    unselected_star &&
    `
    opacity: 0.25;
  `}
`;
